import { render } from "./SubtaskDetailView.vue?vue&type=template&id=1a81fb9b"
import script from "./SubtaskDetailView.vue?vue&type=script&lang=js"
export * from "./SubtaskDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__